const moment = require('moment');
const versionSuffix = moment().format('YYYYMMDDHHmmss');
const versionPrefix = process.env.VERSION_ENV || 'v1.1';
const version = `"${versionPrefix}.${versionSuffix}"`;

module.exports = {
    // API_TYPE: 'allapi',
    API_TYPE: 'api',
    API_TARGET: 'http://localhost:3333',
    //API_TARGET: 'https://www.xcbd-monitor.com',
    // target地址不要提交上来，提交前重置一下
};
